import React, { Component } from 'react'
import { connect } from 'react-redux'
import data from './assets/data'
import { Link } from 'react-router-dom'
import AddToCalendar from 'react-add-to-calendar'
import 'react-add-to-calendar/dist/react-add-to-calendar.min.css'
import { importAll, isOdd } from '../utils/misc'
import Footer from './Footer'
import axios from 'axios';
import backto from './assets/img/backto.png'

// import multiple images
const speakersImg = importAll(require.context('./assets/img/speakers', false, /\.(png|jpe?g|svg)$/));
const nonprofitsImg = importAll(require.context('./assets/img/logos', false, /\.(png|jpe?g|svg)$/));
const sponsorImg = importAll(require.context('./assets/img/hackathon', false, /\.(png|jpe?g|svg)$/));


@connect((store)=>{
  return {
    auth: store.user.auth
  } 
})
class Hackathon extends Component {

  render() {

    // calendar icon
    let icon = { 'fas fa-calendar-plus calendaricon': 'left' };

    let speakers = data.speakers.map((x,key) => {
      return (
        <div key={key} className={isOdd(key) ? 'tile flexChild' : 'tile flexChild flexSort'}>
          {/* <div className="calendarcontainer">
            <AddToCalendar
            buttonLabel={x.event.label}
            event={x.event}
            displayItemIcons={false}
            buttonTemplate={icon} />
          </div> */}
          <img src={speakersImg[x.picture]} alt=""/>
          <div className="info">
          <div className="info-center">
          <div className="name">{x.name}</div>
          <div className="title">{x.title}</div>
          <div className="description">{x.description}</div></div>
        </div>
      </div>
      )
    })

    let nonprofits = data.nonprofits.map((x,key) => {
    return (
    <div key={key} className={isOdd(key)?'tile flexChild':'tile flexChild'}>
    <a href={x.url} rel="nofollow" target="_blank" className="img nonprofits">
    <img src={nonprofitsImg[x.logo]} alt={x.name}/></a></div>)
    })

    let sponsors = data.hackathon.map((x,key) => {
      return (
      <div key={key} className={isOdd(key)?'tile flexChild':'tile flexChild'}>
      <a href={x.url} rel="nofollow" target="_blank" className="img nonprofits">
      <img src={sponsorImg[x.logo]} alt={x.name}/></a></div>)
      })
  

    return (
  <div>
  <section id="section-home" className="section-1 color-1">
    <div className="section-content">
    <a href="/" className="backto" ><img src={backto} width="300px" height="29px" /></a><br/><br/>
    <h1 className="section-title">hack.summit()</h1>
    <h1 className="section-title">Virtual Hackathon</h1>
    <h3 style={{fontWeight: '500',fontSize: '18px',color: 'rgba(255, 255, 255, 0.9)'}} 
    className="section-subtitle">Over $100,000 in prizes</h3>
    <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
    className="section-subtitle">Presented by <a href="https://hack-vc.com" target="_blank">Hack VC</a> and Powered by <a href="http://deco.network" target="_blank">Deco.Network</a> - July 6-8, 2018 </h3>
    <Link to="/register"><button className="btn-register btn btn-primary"> {this.props.auth ? 'View Dashboard' : 'Register now'} </button></Link><br/>
    {/* <div style={{fontWeight: '400',fontSize: '16px',color: 'rgba(255, 255, 255, 0.19)',marginTop:'6px'}}>64793 registrations</div> */}
    <div style={{fontWeight: '400',fontSize: '16px',color: 'rgba(255, 255, 255, 0.19)',marginTop:'6px'}}>hack.summit() registration required</div>
    <h3 id="attendees" className="section-subtitle">
    </h3>
  </div>
  <div className="btn-scroll"></div>
</section>
<section className="color-1 section-short">
  <div className="section-content">
    <h1 className="section-title">Select Sponsors</h1>
    <div className="tiles tiles-partners">
    <div className="flex">
      {sponsors}
      </div>
    </div>
  </div>
</section>
{/* <section className="section-2 color-2">
  <div className="section-content">
    <h1 className="section-title">Work on Cryptos Biggest Problems</h1>
    <h2 className="section-subtitle">Compete to win thousands of dollars in prizes solving problems for the biggest names in blockchain.</h2>
    <div className="tiles tiles-logos">
      <div className="flex">
        {nonprofits}
      </div>
    </div>
  </div>
</section> */}
{/* <section className="section-3 color-3">
  <div className="section-content">
    <h1 className="section-title">Judges & Speakers</h1>
    <div className="tiles tiles-schedule">
    <div className="flex">
      {speakers}
      </div>
    </div>
  </div>
</section> */}
<section className="color-1 section-short">
  <div className="section-content">
    <h1 className="section-title">An epic blockchain weekend</h1>
    <h2 className="section-subtitle">Choose your own team-members</h2>
    <h2 className="section-subtitle">Compete from anywhere in the world</h2>
    <h2 className="section-subtitle">Learn the latest protocols</h2>
    <h2 className="section-subtitle">Win tokens from blockchain foundations</h2>
    <h2 className="section-subtitle">Check our < a href="https://medium.com/@deconet/hack-summit-blockchain-virtual-hackathon-faq-9a559e71f56f" target="_blank">FAQ</a> for more information</h2>
    
  </div>
</section>
<section className="section-4 color-4">
  <div className="section-content">
    <h1 className="section-title">Hack for a Cause</h1>
    <h2 className="section-subtitle">Your participation helps coding non-profits via our sponsor donations</h2>
    <div className="tiles tiles-partners">
    <div className="flex">
      {nonprofits}
      </div>
    </div>
  </div>
</section>
<section className="color-1 section-short">
  <div className="section-content">
    <h1 className="section-title">Our Goals</h1>
    <h2 className="section-subtitle">To solve the biggest problems in blockchain</h2>
    <h2 className="section-subtitle">To raise money for coding non-profits</h2>
    <h2 className="section-subtitle">To unite developers around the world and build community</h2>
  </div>
</section>
<section className="color-2 section-short">
  <div className="section-content">
    <h1 className="section-title">Want to partner with us?</h1>
    <h2 className="section-subtitle">Contact the hack.summit() <a href="mailto:hackathon@hacksummit.org"> Hackathon Team</a></h2>
  </div>
</section>
<Footer/>
      </div>)
    }

}

export default Hackathon;



// WEBPACK FOOTER //
// ./src/components/Hackathon.js